<div *ngIf="loading"
     class="loading-overlay">
  <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
  <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>


<div class="row ">

  <div class="col-12">
    <div class="card border rounded animated fadeIn fast">
      <div class="card-body animated fadeIn fast">


        <!-- cabecera -->
        <div class="row mb-12">

          <div class="col-3">
            <div class="input-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     id="buscaTodo"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     [(ngModel)]="strBuscarTodo"
                     (keyup)="buscarTodo($event)" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        title="Limpiar búsqueda"
                        (click)="limpiaBusca()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-2">
            <div class=" input-group border border-dark rounded">
              <div class="input-group-addon"
                   title="Almacén"><i class="fa-solid fa-warehouse"></i></div>
              <select class="form-control "
                      [(ngModel)]="almSeleccionado"
                      (ngModelChange)="onAlmacenSelect($event)">
                <option value=0>Stock de cualquier almacén</option>
                <option *ngFor="let alm of almacenesList"
                        [value]=alm.id>
                  {{alm.nombre}}
                </option>
              </select>
            </div>
          </div>


          <div class="col-2">
            <div class="input-group border border-dark rounded">
              <div class="input-group-addon"
                   title="Cliente"><i class="fa-solid fa-user"></i></div>
              <select class="form-control"
                      [(ngModel)]="cliSeleccionado"
                      (ngModelChange)="onClienteSelect($event)">
                <!-- [disabled]="selected.length"-->
                <option value=''>Todos los clientes</option>
                <option *ngFor="let cli of clientesList"
                        [value]=cli.id>
                  <span *ngIf="cli.num_pedidos">▶︎​</span>
                  {{cli.nombre}}
                  <span *ngIf="cli.num_pedidos">​ ({{cli.num_pedidos}})</span>
                </option>
              </select>
            </div>
          </div>


          <div class="col-2">
            <div class="demo-checkbox">
              <input id="chkMenu"
                     type="checkbox"
                     class="filled-in"
                     [(ngModel)]="selectAllRows"
                     (ngModelChange)="toggleSelectAllRows()" />
              <label for="chkMenu">Seleccionar todo </label>
            </div>
          </div>


          <div class="col-3">
            <form>
              <div class="row float-right">

                <div class="col-7">
                  <div class="form-group rounded">
                    <select class="form-control"
                            name="rowsLimitStr"
                            [(ngModel)]="rowsLimitStr"
                            (change)="rowsLimitChange()">
                      <option [value]="10">10</option>
                      <option [value]="50">50</option>
                      <option [value]="100">100</option>
                      <option [value]="999999">Todo</option>
                    </select>
                  </div>
                </div>

                <div class="col-5">
                  <div class="form-group float-right">
                    <div class="btn-group">
                      <button type="button"
                              (click)="cargaPedidosList()"
                              class="btn btn-outline-info btn-circle"
                              title="Recargar datos">
                        <i class="fa-solid fa-sync"></i>
                      </button>
                      <button type="button"
                              [ngClass]="{'disabled': loading}"
                              (click)="exportToExcel()"
                              class="btn btn-outline-info btn-circle"
                              title="Descargar Excel">
                        <i class="fa-solid fa-download"></i>
                      </button>

                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>

        </div>




        <div class="rounded border">
          <small>Selecciona los pedidos para la/s nueva/s campaña/s</small>

          <!-- datatable -->
          <ngx-datatable class="bootstrap pointer"
                         [rows]="rows"
                         [columnMode]="ColumnMode.flex"
                         [headerHeight]="50"
                         [footerHeight]="50"
                         [messages]="messages"
                         rowHeight="auto"
                         [limit]="rowsLimit"
                         [selected]="selected"
                         [selectionType]="SelectionType.multiClick"
                         (activate)="onActivate($event)"
                         [summaryRow]="true"
                         [summaryHeight]="50"
                         [summaryPosition]="summaryPosition">


            <!-- id -->
            <ngx-datatable-column name="id"
                                  [flexGrow]="70">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">id</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- fecha_pedido -->
            <ngx-datatable-column name="Fecha pedido"
                                  prop='fecha_pedido'
                                  [flexGrow]="130">
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value | date:'yyyy/MM/dd HH:mm', textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- cliNombre -->
            <ngx-datatable-column name="Cliente"
                                  prop='cliNombre'
                                  [flexGrow]="100">
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
              </ng-template>
            </ngx-datatable-column>

            <!-- cliIcono -->
            <ngx-datatable-column name=""
                                  prop='cliIcono'
                                  [flexGrow]="30"
                                  [resizeable]="false">
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <span *ngIf="row.tipo==='M'"
                      class="text-secondary"
                      style="display: inline-block;"
                      title="Creado manualmente por el cliente desde su Intranet">
                  <i class="fa-solid fa-laptop"></i>
                </span>

              </ng-template>
            </ngx-datatable-column>


            <!-- pedido_cli -->
            <ngx-datatable-column name="Pedido"
                                  prop='pedido_cli'
                                  [flexGrow]="150"
                                  [summaryFunc]="cuentaCeldas">
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [ngClass]="{ 'text-warning arrow': row.estado.toString().startsWith('8') }">

                  <span *ngIf="row.estado === 81"
                        class="mr-1 text-warning"
                        title="Contiene artículos no referenciados"
                        style="display: inline-block;">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                  </span>
                  <span *ngIf="row.estado === 71"
                        class="mr-1 text-info"
                        title="Contiene artículos con STOCK insuficiente"
                        style="display: inline-block;">
                    <i class="fa-solid fa-circle-info"></i>
                  </span>
                  <span *ngIf="row.estado === 83"
                        class="mr-1 text-danger"
                        title="Este pedido NO tiene líneas de detalle"
                        style="display: inline-block;">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                  </span>
                  <span *ngIf="row.estado === 84"
                        class="mr-1 text-danger"
                        title="Pedido sin referencia por parte del cliente"
                        style="display: inline-block;">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                  </span>
                  <span *ngIf="row.estado === 85"
                        class="mr-1 text-danger"
                        title="Pedido de un cliente NO reconocido"
                        style="display: inline-block;">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                  </span>
                  <span *ngIf="row.estado === 86"
                        class="mr-1 text-danger"
                        title="Pedido ya existente para este cliente"
                        style="display: inline-block;">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                  </span>

                  <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"
                        [class.font-weight-bold]="row.destacarLinea"
                        [class.text-primary]="row.destacarLinea"></span>
                </div>
              </ng-template>
            </ngx-datatable-column>




            <!-- estado -->
            <ngx-datatable-column name="Estado"
                                  prop='estado'
                                  [flexGrow]="160"
                                  [summaryFunc]="noSummary">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <span [innerHTML]="value | pedidoExternoEstado "> </span>
              </ng-template>
            </ngx-datatable-column>



            <!-- tot_articulos -->
            <ngx-datatable-column name="Articulos"
                                  prop='tot_articulos'
                                  [flexGrow]="85"
                                  [cellClass]="'text-right'"
                                  [summaryFunc]="sumaCeldas">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- tot_referencias -->
            <ngx-datatable-column name="Refs."
                                  prop='tot_referencias'
                                  [flexGrow]="85"
                                  [cellClass]="'text-right'"
                                  [summaryFunc]="sumaCeldas">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- poblacion -->
            <ngx-datatable-column name="Población"
                                  [flexGrow]="200">
              <ng-template let-row="row"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto( row.cp+'-'+row.poblacion, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- pais_iso -->
            <ngx-datatable-column name="País"
                                  prop='pais_iso'
                                  [flexGrow]="85">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- cod_servicio -->
            <ngx-datatable-column name="Servicio"
                                  prop='cod_servicio'
                                  [flexGrow]="85">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [ngClass]="{ 'text-warning font-weight-bold' : value === 'inte' }"
                     [innerHTML]="funcLib.resaltarTexto(  value, textoDestacado)  "></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- contrarrembolso -->
            <ngx-datatable-column name="Reemb."
                                  prop='contrarrembolso'
                                  [flexGrow]="90"
                                  [cellClass]="'text-right'"
                                  [summaryFunc]="sumaCeldas">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <ng-container *ngIf="value">
                  {{ value | number: '0.0-2':'es'}} €
                </ng-container>
              </ng-template>
            </ngx-datatable-column>


            <!-- nombre -->
            <ngx-datatable-column name="Destinatario"
                                  prop='nombre'
                                  [flexGrow]="200">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- Ver pedido-->
            <!-- <ngx-datatable-column name=""
                                  [flexGrow]="60"
                                  [sortable]="false">
              <ng-template let-row="row"
                           ngx-datatable-cell-template>
                <button [disabled]="loading"
                        class="no-select btn btn-info btn-xs"
                        ng-di
                        (click)="infoPedido($event, row)">Info xx</button>



              </ng-template>
            </ngx-datatable-column> -->



            <!-- Acciones -->
            <ngx-datatable-column [flexGrow]="120"
                                  [sortable]="false">

              <ng-template let-row="row"
                           let-value="value"
                           ngx-datatable-cell-template>

                <div class="d-flex align-items-center gap-1">

                  <a class="link mr-1 pointer"
                     title="INFORMACIÓN del pedido"
                     (click)="infoPedido($event, row)">
                    <span class="acciones-badge"
                          [ngClass]="{'infoSelect': row.destacarLinea}">
                      I
                    </span>
                  </a>



                  <div ngbDropdown
                       class="d-inline-block "
                       container="body">
                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                            data-toggle="dropdown"
                            type="button"
                            style="border-width: 1px;">
                      <i class="fa-solid fa-ellipsis-vertical"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-left">

                      <!-- <a (click)="infoPedido($event, row)"
                         class="link mr-2 dropdown-item"
                         placement="top"
                         title="INFORMACIÓN de este pedido">
                        <i class="fa-solid fa-info-circle"></i> INFORMACIÓN del pedido
                      </a> -->

                      <a (click)="avisarCliente($event, row)"
                         class="link mr-2 dropdown-item"
                         placement="top"
                         title="NOTIFICAR al cliente">
                        <i class="fa-solid fa-envelope"></i> NOTIFICAR al cliente
                      </a>

                      <hr style="margin: 0px;">

                      <a (click)="delPedido($event, row)"
                         class="link mr-2 pointer dropdown-item text-danger"
                         title="Borrar pedido">
                        <i class="fa-regular fa-trash-can fa"></i> Borrar
                      </a>


                    </div>
                  </div>

                </div> <!-- "d-flex align-items-center gap-1 -->

              </ng-template>
            </ngx-datatable-column>







          </ngx-datatable>
        </div>




        <div *ngIf="selected.length">


          <!-- form de detall -->
          <form class="form p-t-20"
                [formGroup]="campForm"
                (ngSubmit)="enviar()"
                class="form-horizontal">


            <div class="form-body">

              <h4 class="card-title text-info"></h4>
              <h6 class="card-subtitle"></h6>

              <div class="card border border-dark rounded mt-4 p-1">
                <div class="row">

                  <!-- descripcion -->
                  <div class="col-md-12">
                    <div class="form-group"
                         [ngClass]="{ 'has-danger': enviado && f['descripcion'].errors }">
                      <label class="form-control-label">Descripción:</label>
                      <input type="text"
                             formControlName="descripcion"
                             class="form-control"
                             [ngClass]="{ 'form-control-danger': enviado && f['descripcion'].errors }">

                      <div *ngIf="enviado && f['descripcion'].errors"
                           class="form-control-feedback">
                        <div *ngIf="f['descripcion'].errors['required']">Obligatorio</div>
                        <div *ngIf="campForm.get('descripcion')?.errors?.['apiError']">
                          {{campForm.get('descripcion')?.errors?.['apiError'] }}
                        </div>

                      </div>
                    </div>
                  </div>

                </div> <!-- row -->

              </div>
            </div>


            <hr>

            <div class="d-flex">
              <button [disabled]="loading"
                      type="button"
                      class="btn waves-effect waves-light btn-rounded btn-secondary"
                      [routerLink]="'/panel/campanyas_lista'">Cancelar</button>


              <button [disabled]="loading"
                      *ngIf="selected.length===1"
                      type="button"
                      (click)="unoAunoClick()"
                      class="ml-auto btn waves-effect waves-light btn-rounded btn-success">
                <i *ngIf="loading"
                   class="fa fa-spinner fa-spin"></i>
                Crear pedido 1 a 1
                <img src="../../../assets/images/icon/1a1.png"
                     height="25px"
                     alt="1 a 1"
                     class="d-inline-block ms-2">
              </button>

              <button [disabled]="loading"
                      type="submit"
                      class="ml-auto btn waves-effect waves-light btn-rounded btn-success">
                <i *ngIf="loading"
                   class="fa fa-spinner fa-spin"></i>
                Crear {{cuentaClientes}} campaña{{ cuentaClientes !== 1 ? 's' : '' }}</button>

            </div>

          </form>
        </div>

      </div> <!-- card-body -->

    </div>
  </div>

</div>




<!-- Alertas -->
<div class="row">
  <div class="col-12">

    <div *ngIf="pedidoInfo.estado === Constantes.ESTADO_PEDIDO_EXT_ARTICULO_NO_EXISTE"
         class="alert alert-warning"> <i class="fa-solid fa-triangle-exclamation"></i> <strong> Atención</strong>
      Este pedido contiene artículos no referenciados en el maestro de artículos para este cliente.
      <button [disabled]="loading"
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"> <span aria-hidden="true">×</span> </button>
    </div>
    <div *ngIf="pedidoInfo.estado === 71"
         class="alert alert-info"> <i class="fa-solid fa-circle-info"></i> <strong> Atención</strong>
      Este pedido contiene artículos con STOCK insuficiente para ser servido.
      <button [disabled]="loading"
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"> <span aria-hidden="true">×</span> </button>
    </div>
    <div *ngIf="pedidoInfo.estado === 81"
         class="alert alert-warning"> <i class="fa-solid fa-triangle-exclamation"></i> <strong> Atención</strong>
      Contiene artículos no referenciados.
      <button [disabled]="loading"
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"> <span aria-hidden="true">×</span> </button>
    </div>

    <div *ngIf="pedidoInfo.estado === 83"
         class="alert alert-danger"> <i class="fa-solid fa-triangle-exclamation"></i> <strong> Atención</strong>
      No se ha podido encontrar ninguna línea de detalle para este pedido.
      <button [disabled]="loading"
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"> <span aria-hidden="true">×</span> </button>
    </div>

    <div *ngIf="pedidoInfo.estado === 84"
         class="alert alert-danger"> <i class="fa-solid fa-triangle-exclamation"></i> <strong> Atención</strong>
      Este pedido NO tiene referencia por parte del cliente.
      <button [disabled]="loading"
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"> <span aria-hidden="true">×</span> </button>
    </div>
    <div *ngIf="pedidoInfo.estado === 85"
         class="alert alert-danger"> <i class="fa-solid fa-triangle-exclamation"></i> <strong> Atención</strong>
      Este pedido es de un cliente NO reconocido.
      <button [disabled]="loading"
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"> <span aria-hidden="true">×</span> </button>
    </div>
    <div *ngIf="pedidoInfo.estado === 86"
         class="alert alert-danger"> <i class="fa-solid fa-triangle-exclamation"></i> <strong> Atención</strong>
      Ya existente un pedido anterior con esta referencia para este cliente
      <button [disabled]="loading"
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"> <span aria-hidden="true">×</span> </button>
    </div>


  </div>
</div>




<!-- Tabla de detalle de la entrada seleccionada -->
<div *ngIf="pedidosList.length || pedidoInfo.estado === 83"
     class="col-12">

  <div class="card">

    <div class="card-body">
      <h5 class="card-title">Detalle del pedido</h5>
      <div class="row">

        <div class="col-4 ">
          <div class="border border-dark rounded p-2 h-100">

            <div>
              <span class="font-weight-bold"> {{pedidoInfo?.cliNombre}} </span>
              <br>
              Pedido: <span class="text-info font-weight-bold"> {{pedidoInfo?.pedido_cli}} </span>
              <span [innerHTML]=" pedidoInfo?.estado | pedidoExternoEstado "> </span>
              <span class="font-italic text-muted text-sm"> {{ pedidoInfo?.estado_at }}</span>
            </div>
            <div class="mb-2">
              <span class="d-block">
                Servicio: <span class="text-info">{{pedidoInfo?.servicio?.codServicio}}</span> - {{pedidoInfo?.servicio?.nombre}}<br>
                Referencia: <span class="text-info">{{pedidoInfo?.ref_envio}}</span>
              </span>
            </div>

          </div>
        </div>


        <div class="col-4 ">
          <div class="border border-dark rounded p-2 h-100">

            <h4 class="card-title">Destinatario</h4>
            <h6 class="card-subtitle">
              <span class="text-info"> {{pedidoInfo?.nombre}}</span>
              <span *ngIf="pedidoInfo?.contrarrembolso && pedidoInfo?.contrarrembolso > 0"
                    class="text-danger font-italic text-sm"><br>
                (contrarrembolso de {{ pedidoInfo?.contrarrembolso | number: '0.0-0':'es'}} €)
              </span>
              <br>
              {{pedidoInfo?.direccion}} <br>
              {{pedidoInfo?.cp}} - {{pedidoInfo?.poblacion}} <br>
              {{pedidoInfo?.provincia}} - {{pedidoInfo?.pais_iso}}
            </h6>

          </div>
        </div>



        <div class="col-4 ">
          <div class="border border-dark rounded p-2 h-100">

            <h4 class="card-title">Origen del pedido</h4>
            <h6 class="card-subtitle">
              <span class="font-weight-bold"
                    [innerHTML]=" pedidoInfo?.tipo | pedidoExternoTipo "> </span>
              <br>
              <span *ngIf="pedidoInfo?.origen"
                    class="text-info">Fuente:</span> {{pedidoInfo?.origen}}
              <span *ngIf="pedidoInfo?.origen_linea"
                    class="text-info">Línea:</span> {{pedidoInfo?.origen_linea}}
              <span *ngIf="pedidoInfo?.i_complemetarios"
                    class="text-info">COMPLEMENTARIO:</span> {{pedidoInfo?.i_complemetarios}}
              <br><br>
              <span class="text-info">Artículos:</span> {{pedidoInfo?.tot_articulos}}
              <span class="text-info">Referencias:</span> {{pedidoInfo?.tot_referencias}}
            </h6>

          </div>
        </div>
      </div> <!-- row -->



      <div class="card-body">
        <h4 class="card-title">Detalle del Pedido <b class="text-primary">{{pedidoInfo?.pedidoCli}}</b> de {{pedidoInfo?.cliNombre}}</h4>
        <h6 class="card-subtitle">Artículos</h6>
        <div class="bootstrap-table">


          <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered table-hover">

              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>Id</th>
                  <th>Sku</th>
                  <th><i class="fa fa-barcode"></i> Ean</th>
                  <th>Artículo</th>
                  <th style="text-align: right; padding-right: 30px">Cantidad</th>
                  <th style="text-align: right; padding-right: 30px">Stock</th>
                  <th style="text-align: right; padding-right: 30px">Reservado</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngFor="let lin of pedidosList; let i = index">
                  <tr [ngClass]="{'text-danger': lin.estado && lin.estado.toString().startsWith('8') }">
                    <td style="text-align: center;">
                      <span *ngIf="lin.estado === 81">
                        <a href="javascript: void(0);"
                           [routerLink]="'/panel/articulo_edit/E' + lin.id"
                           title="Crear artículo">
                          <i class="fa-solid fa-circle-plus"></i>
                        </a>
                      </span>
                    </td>

                    <td style="text-align: center;">
                      <a [routerLink]="['/panel/articulos_lista' ]"
                         [queryParams]="{ articuloExterno_id: lin.id, id_cliente: pedidoInfo.id_cliente, cliNombre: pedidoInfo.cliNombre  }"
                         title="Cambiar por otro artículo">
                        <i class="fa-solid fa-repeat"></i>
                      </a>
                    </td>


                    <td>
                      <img [src]="fotoDir +'/articulos' + imgResized +  lin.artFoto"
                           loading="lazy"
                           class="rounded pointer border"
                           height="25px"
                           (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + lin.artFoto)">
                    </td>
                    <td>{{ lin.id_articulo }}</td>
                    <td>{{ lin.artSku }}</td>
                    <td>{{ lin.artEan }}</td>
                    <td>{{ lin.artDescripcion }}</td>
                    <td style="text-align: right; padding-left: 10px">
                      <span *ngIf="lin.cantidad > lin.artStock"
                            class="badge badge-danger monospace"
                            title="Cantidad pedida supera el stock disponible">
                        {{lin.cantidad | number: '0.0-0':'es'}}
                      </span>
                      <span *ngIf="lin.cantidad <= lin.artStock"
                            class="monospace">
                        {{lin.cantidad | number: '0.0-0':'es'}}
                      </span>
                    </td>
                    <td style="text-align: right; padding-left: 10px">
                      <div class="pl-25 mr-20 monospace">
                        {{lin.artStock | number: '0.0-0':'es'}}
                      </div>
                    </td>
                    <td style="text-align: right; padding-left: 10px">
                      <div class="pl-25 mr-20 monospace">
                        {{lin.stockRes | number: '0.0-0':'es'}}
                      </div>
                    </td>


                    <td style="text-align: center;">
                      <div ngbDropdown
                           class="d-inline-block "
                           container="body">
                        <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                data-toggle="dropdown"
                                type="button"
                                style="border-width: 1px;">
                          <i class="fa-solid fa-ellipsis-vertical"></i>
                        </button>

                        <div class="dropdown-menu dropdown-menu-left">
                          <a [routerLink]="lin.estado === 81 ? ['/panel/articulo_edit/E' + lin.id] : null"
                             class="link mr-2 dropdown-item"
                             placement="top"
                             title="Crear un nuevo artículo con estos datos"
                             [class.disabled]="lin.estado !== 81"
                             [attr.aria-disabled]="lin.estado !== 81"
                             (click)="lin.estado !== 81 && $event.preventDefault()">
                            <i class="fa-solid fa-circle-plus"></i> Crear artículo
                          </a>
                          <a [routerLink]="['/panel/articulos_lista' ]"
                             [queryParams]="{ articuloExterno_id: lin.id, id_cliente: pedidoInfo.id_cliente, cliNombre: pedidoInfo.cliNombre  }"
                             class="link mr-2 dropdown-item"
                             placement="top"
                             title="Seleccionar otro artículo de este clietne">
                            <i class="fa-solid fa-repeat"></i> Cambiar por otro artículo
                          </a>
                          <a (click)="lin.estado !== 81 && eanLabelsSrv.imprimirEanLabel(lin.id_articulo)"
                             class="link mr-2 dropdown-item"
                             placement="top"
                             title="Generar etiquetas EAN"
                             [class.disabled]="lin.estado == 81"
                             [attr.aria-disabled]="lin.estado === 81">
                            <i class="fa-solid fa-barcode"></i> Generar etiquetas EAN
                          </a>
                        </div>

                      </div>
                    </td>

                  </tr>

                </ng-container>
              </tbody>

              <tfoot>
                <tr class="font-weight-bold bg-light">
                  <td colspan="6"
                      style="text-align: right;">TOTALES</td>
                  <td style="text-align: left; padding-left: 10px">
                    <div class="pl-25 mr-20 monospace">
                      {{pedidosList.length | number: '0.0-0':'es'}}
                    </div>
                  </td>
                  <td style="text-align: right; padding-left: 10px">
                    <div class="pl-25 mr-20 monospace">
                      {{totalCantidad | number: '0.0-0':'es'}}
                    </div>
                  </td>
                  <td style="text-align: right; padding-left: 10px">
                    <div class="pl-25 mr-20 monospace">
                      <!-- {{totalStock | number: '0.0-0':'es'}} -->
                    </div>
                  </td>
                  <td style="text-align: right; padding-left: 10px">
                    <div class="pl-25 mr-20 monospace">
                      {{totalReservado | number: '0.0-0':'es'}}
                    </div>
                  </td>
                  <td></td>
                </tr>
              </tfoot>

            </table>
          </div>


        </div>
      </div>

      <div class="clearfix"></div>
    </div>

  </div>



</div>


<!-- Modal para mostrar la imagen -->
<div class="modal-overlay"
     *ngIf="imagenSeleccionada"
     (click)="cerrarPopupImagen()">
  <div class="modal-content">
    <img [src]="imagenSeleccionada"
         class="modal-image"
         alt="Imagen seleccionada">
  </div>
</div>